export default __webpack_public_path__ + "static/media/x-black.be44444d.svg";